export default __webpack_public_path__ + "static/media/mec_logo.a06dac18.png";